<div class="w-full mx-auto mt-8 rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <p class="titre2">{{ 'TAGS_MANAGEMENT.USERS_FOR_TAG' | translate }}</p>
  </div>
  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    @if (isLoading) {
      <div class="flex justify-center items-center mt-8">
        <mat-spinner diameter="40" color="accent"></mat-spinner>
      </div>
    }
    @if (!isLoading) {
      <div class="mb-6">
        <h3 class="text-lg font-semibold mb-3">{{ 'TAGS_MANAGEMENT.ACTIVE_USERS' | translate }}</h3>
        @if (utilisateursActifs.length > 0) {
          <div>
            @for (utilisateur of utilisateursActifs; track utilisateur) {
              <div>
                <div class="text-base font-medium mb-2">{{utilisateur.nom}}</div>
              </div>
            }
          </div>
        }
        @if (utilisateursActifs.length === 0) {
          <div class="text-center mt-2 text-gray-500">
            {{ 'TAGS_MANAGEMENT.NO_ACTIVE_USERS' | translate }}
          </div>
        }
      </div>
      <div class="mb-6">
        <h3 class="text-lg font-semibold mb-3">{{ 'TAGS_MANAGEMENT.INACTIVE_USERS' | translate }}</h3>
        @if (utilisateursInactifs.length > 0) {
          <div>
            @for (utilisateur of utilisateursInactifs; track utilisateur) {
              <div>
                <div class="text-base font-medium mb-2">{{utilisateur.nom}}</div>
              </div>
            }
          </div>
        }
        @if (utilisateursInactifs.length === 0) {
          <div class="text-center mt-2 text-gray-500">
            {{ 'TAGS_MANAGEMENT.NO_INACTIVE_USERS' | translate }}
          </div>
        }
      </div>
      @if (utilisateurs.length === 0) {
        <div class="text-center mt-4 text-gray-500">
          {{ 'TAGS_MANAGEMENT.NO_USERS_FOR_TAG' | translate }}
        </div>
      }
    }
  </div>
  <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end gap-6">
    <button type="button" (click)="closeDialog()" class="btn-secondary-novo">
      {{ 'TAGS_MANAGEMENT.CLOSE' | translate }}
    </button>
  </div>
</div>
